import type { ComponentType } from 'react';
import {
  getRenderer as registryGetRenderer,
  registerRenderer as registryRegisterRenderer,
  type RendererProps,
} from '../../registry.js';
import { BUILTIN_RENDERERS } from './builtin-renderers.js';

// Re-export for back-compat with consumers that imported from here.
export type { RendererProps as CatalogComponentProps } from '../../registry.js';

export const CATALOG_ID = 'deckspace/standard';

export interface CatalogPropDef {
  type: 'string' | 'number' | 'boolean' | 'object' | 'array';
  required?: boolean;
  description?: string;
  enum?: string[];
}

export interface CatalogEntry {
  type: string;
  category: 'layout' | 'content' | 'data' | 'interactive' | 'domain';
  props: Record<string, CatalogPropDef>;
  component: ComponentType<RendererProps>;
}

/**
 * Canonical list of built-in renderer types. Derived from BUILTIN_RENDERERS
 * so it stays in sync with what ui-components ships.
 */
export const ALL_CATALOG_TYPES = Object.keys(BUILTIN_RENDERERS);

export function getCatalogComponent(type: string): ComponentType<RendererProps> | undefined {
  return registryGetRenderer(type);
}

/**
 * Back-compat shim — older test code calls this to register a test
 * component. New code should call `registerRenderer` directly.
 *
 * @deprecated Use `registerRenderer` from `@deckspace/ui` instead.
 */
export function registerCatalogEntry(type: string, component: ComponentType<RendererProps>): void {
  registryRegisterRenderer(type, component);
}

// Re-export the registry API at this surface for adjacent code.
export {
  registerRenderer,
  getRenderer,
  getRegisteredTypes,
  clearRenderers,
} from '../../registry.js';
